module.exports = __webpack_public_path__ + "img/battery-alarm.735abe7a.svg";